module.exports = __webpack_public_path__ + "img/depmap_svg_V201.caeb3936.svg";